import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { ADD_EVENT } from '../../redux/reducers/eventReducer';
import { zenworksServiceApi } from '../../service/zenworksService.api';
import getTimeStamp from '../../utils/getTimeStamp';
import { generateRandomId } from '../../utils/global.utils';

const FeedbackRating = () => {
  const { socket, socketIdClosed } = useSelector(
    (state: RootState) => state.socketConnection,
  );
  const dispatch = useDispatch<AppDispatch>();
  const isSubmittedRef = useRef(false);

  const [rating, setRating] = useState<number>(0);

  const handleStarClick = (star: number) => {
    setRating(star);
    // onRatingChange(star);
  };

  const handelSubmit = async () => {
    const socketId = (socket && socket.id) || socketIdClosed;
    try {
      const res = await zenworksServiceApi.submitFeedback({
        rating,
        socketId,
      });
      if (res.id) {
        const timeStamp = getTimeStamp();
        const divId = generateRandomId();
        dispatch({
          type: ADD_EVENT,
          payload: {
            type: 'messageCard',
            id: divId,
            divId,
            user: 'actionCard',
            time: timeStamp,
            msg: 'Thank You for Your Feedback!',
            senderType: 'chatBot',
          },
        });
        isSubmittedRef.current = true;
      }
    } catch (err) {
      console.error('err:', err);
    }
  };

  return (
    <div className="flex items-center justify-items-center justify-center  space-x-1">
      <div>
        <div className="p-10 text-center">
          <p className="py-2">Please share your feedback with us</p>
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              onClick={() => handleStarClick(star)}
              // disabled={connectionStatus !== 'Connected'}
              className={`outline-none text-4xl m-2 ${
                star <= rating ? 'scale-125' : 'text-gray-400'
              }`}
              disabled={isSubmittedRef.current}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="30"
                width="30"
                fill={star <= rating ? '#FFD700' : 'gray'}
                viewBox="0 0 576 512"
              >
                <path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
              </svg>
            </button>
          ))}
        </div>
        <div className="text-center">
          <button
            onClick={handelSubmit}
            // disabled={connectionStatus !== 'Connected'}
            className={`outline-none text-sm p-2 w-full rounded-full bg-primary text-white enabled:hover:bg-blue-900 disabled:bg-gray-400 focus:outline-none`}
            disabled={isSubmittedRef.current}
          >
            Submit Feedback
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackRating;
